<template>
  <!--
    The navigator sits on the home page, allowing the user to navigate to different
    page through filters.
  -->
  <div class="wrapper">
    <nav
      aria-label="Curriculum Navigation"
      class="navigator heading-x-small"
    >
      <span
        aria-hidden="true"
        class="navigator__sub-text"
      >I am a </span>

      <SelectList
        name="Select Role"
        aria="I am a"
        :list="roles"
        :value="navigatorRole"
        @changed="setRole"
      />

      <span
        aria-hidden="true"
        class="navigator__sub-text"
      >at</span>

      <SelectList
        name="Select Year level"
        :aria="`I am a ${navigatorRole} at`"
        :list="yearTextList"
        :value="navigatorYears"
        @changed="setYears"
      />

      <span
        aria-hidden="true"
        class="navigator__sub-text"
      >looking for</span>

      <SelectList
        name="Select Content"
        :aria="`I am a ${navigatorRole} at ${navigatorYears.replace('-', ' to ')} looking for`"
        :list="goTo"
        :value="navigatorGoTo"
        @changed="setGoTo"
      />

      <a
        class="c-button navigator__go"
        :href="computedUrl"
        target="blank"
        :aria-label="computedAria"
        :title="computedAria"
      >
        GO
        <img
          src="/themes/custom/education_base/assets/images/icon-bold-arrow-right.svg"
          alt=""
        >
      </a>
    </nav>
  </div>
</template>

<script>
import SelectList from './SelectList.vue';

export default {
  name: 'Navigator',
  components: {
    SelectList,
  },
  props: {
    years: {
      type: String,
      required: true,
    },
    types: {
      type: String,
      required: true,
    },
  },
  data() {
    const raw = JSON.parse(this.years);
    raw.push({ name: 'All Years', id: null });

    return {
      yearObjects: raw,
      typeObjects: JSON.parse(this.types),
      roles: ['Teacher', 'School Leader'],
      goTo: ['Curriculum Content', 'Resources', 'An Introduction'],
      navigatorRole: 'Teacher',
      navigatorYears: 'Years 1-3',
      navigatorGoTo: 'Curriculum Content',
    };
  },
  computed: {
    allSelected() {
      return this.navigatorYears === 'All Years';
    },
    yearID() {
      return this.yearObjects?.find((a) => a.name === this.navigatorYears).id;
    },
    guidanceID() {
      return this.typeObjects?.find((a) => a.name === 'Leadership Guidance').id;
    },
    yearResourceUrl() {
      return this.allSelected ? '' : `?f%5B0%5D=year_level%3A${this.yearID}`;
      // return this.allSelected ? '' : `/year_level/${this.yearID}`;
    },
    yearTextList() {
      return this.yearObjects?.map((a) => a.name);
    },
    yearUrl() {
      return this.navigatorYears.toLowerCase().replace(' ', '-');
    },
    yearAria() {
      return this.navigatorYears.replace('-', ' to ');
    },
    computedAria() {
      switch (this.navigatorGoTo) {
        case 'Curriculum Content':
          return `Go to ${this.allSelected ? 'overview' : `${this.yearAria} curriculum`} page`;
        case 'An Introduction':
          return 'Go to introduction page';
        case 'Resources':
          return `Go to ${this.yearAria} resources`;
        default:
          return '';
      }
    },
    computedUrl() {
      switch (this.navigatorGoTo) {
        case 'Curriculum Content':
          return this.allSelected ? '/content-overview' : `/${this.yearUrl}/know`;
        case 'An Introduction':
          return '/about/content-structure';
        case 'Resources':
          return `/resources${this.yearResourceUrl}${this.navigatorRole === 'School Leader' ? `&f%5B0%5D=type%3A${this.guidanceID}` : ''}`;
        default:
          return '/';
      }
    },
  },
  methods: {
    setRole(v) { this.navigatorRole = v; },
    setYears(v) { this.navigatorYears = v; },
    setGoTo(v) { this.navigatorGoTo = v; },
  },
};
</script>

<style scoped lang="scss">
$navigator-width: 48rem;
$navigator-height: 4.2rem;
$margin-top: calc(#{-$navigator-height} / 2 - (0.6rem));

.wrapper { @include education-breakpoint-tablet-down { padding: 0 2rem; } }

.navigator {
  width: $navigator-width;
  height: $navigator-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: $margin-top auto 0 auto;
  padding: 1rem 1.6rem;
  background: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  transition: all 200ms ease-in;

  @include education-breakpoint-tablet-down {
    @include text-tiny;

    font-weight: bold;
    max-width: 100%;
  }

  @include education-breakpoint-mobile-down {
    width: 13.5rem;
    height: 13.5rem;
    flex-direction: column;
    align-items: center;

    .navigator__sub-text { display: none; }
  }

  &__go {
    height: 100%;
    padding: 0 0.7rem;
    color: white;
    font-weight: bold;
    border-radius: 5px;

    @include hover-focus-active { color: white; }

    @include education-breakpoint-mobile-down {
      height: 2.25rem;
      width: 5rem;
      padding: 0 0.5rem;
    }

    img { padding-left: 0.5rem; }
  }
}
</style>
